import {Component, Inject, OnInit} from 'ng-metadata/core';
import {UnionCatalogLoginService} from './unionCatalogLogin.service';
import {LoginService} from "../login.service";

@Component({
    selector: 'prm-union-catalog-login',
    templateUrl: 'components/security/login/unionCatalogLogin/union-catalog-login.html',
})

export class PrmUnionCatalogLogin implements OnInit{
    private readonly _unionCatalogInstitutionsList;
    constructor(private unionCatalogLoginService : UnionCatalogLoginService,
                private loginService : LoginService,
                @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('loginIcons') public loginIcons) {
        this._unionCatalogInstitutionsList = this.unionCatalogLoginService.getMemberInstitutionList();
    }

    ngOnInit() {
    }

    get unionCatalogInstitutionsList(){
        return this._unionCatalogInstitutionsList;
    }

    goToInstitutionLogin(institutionDetails){
        this.unionCatalogLoginService.goToInstitutionLogin(institutionDetails)
    }

    public cancelLogin() {
        this.loginService.removeBackgroundDarkClass();
        this.loginService.clearSavedState();
        this.$mdDialog.cancel();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/unionCatalogLogin.directive.ts